import React from "react";
import { HowToBuyContainer } from "../../containers/how-to-buy/HowToBuyContainer";

export const HowToBuy = () => (<HowToBuyContainer />);

export default HowToBuy;